<template>
    <vs-popup title="سفارش سرویس" class="addService" :active.sync="showPopup">
        <div class="mb-base">
            <form class="px-4" @keydown.enter.prevent.self>
                <vs-row class="pb-5">
                    <vs-col vs-lg="5" vs-md="5" vs-sm="12">
                        <label class="vs-input--label">انتخاب کاربر</label>
                        <v-select :options="usersList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="user_id" :clearable="false">
                        </v-select>
                    </vs-col>
                    <vs-col vs-lg="7" vs-md="7" vs-sm="12">
                        <label class="vs-input--label input-left">نوع دسته بندی</label>
                        <v-select :options="categoryList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="category" class="input-left" :clearable="false" />
                    </vs-col>
                </vs-row>
                <vs-textarea v-model="details" counter="350" class="service-textarea mt-4" :counter-danger.sync="counterDanger" />
                <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-col class="sm:w-1/2 w-full">
                        
                    </vs-col>
                    <vs-col class="sm:w-1/2 w-full">
                        <vs-button class="mr-3 float-right" :disabled="counterDanger || !validateForm" @click="addOrderInfo()">ثبت سرویس</vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'AddOrderService',
    props: {
        popupAddOrder: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        vSelect,
    },
    
    data() {
		return{
            showPopup: false,
            details: '',
            category: '',
            user_id: '',
            counterDanger: false,
		}
    },
    
    computed: {
        categoryList() {
      		return {
                items: this.$store.state.orders.category.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                        admin : `${robot.admin}`
                    }
                })
            }
        },
        usersList() {
            return {
                items: this.$store.state.users.users.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name} ${robot.last_name}`,
                    }
                })
            }
		},

        validateForm() {
            return this.user_id != '' && this.category != '';
        },
    },

    watch: { 
      	popupAddOrder: function(newVal) {
            this.showPopup = newVal
            if(newVal == true) {
                this.$vs.loading()
                this.getUser()
                this.$store.dispatch('getSystemInfo')
                .then(() => {
                    this.$vs.loading.close()
                })
                .catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupAddOrder', newVal)
            this.details = ''
            this.category = ''
            this.user_id = ''
        },
    },

    created(){
    },
    
    methods: {
        getUser(){
			this.$store.dispatch('getAllUsers').catch(() => {
                this.$vs.notify({
                    title: '',
                    text: 'خطا در اتصال به اینترنت',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            })
        },
        
        addOrderInfo(){
            this.$vs.loading()
            this.$emit('updatePopupAddOrder', false)
            let payload = {
                orders: this.details,
                category: {
                    id: parseInt(this.category.value),
                    name: this.category.label,
                    admin: parseInt(this.category.admin),
                },
                user_id: this.user_id.value,
                type: 'service',
                message: this.details
            }
            payload = { 
                data: JSON.stringify(payload)
            }
            this.details =''
            this.category = ''
            this.user_id = ''
			this.$store.dispatch('addOrder', payload)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'سفارش سرویس با موفقیت افزوده شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        },
    }
}
</script>

<style scope>
.addService .vs-popup {
    width: 50% !important;
}

@media (max-width: 720px) {
    .addService .vs-popup {
        width: 90% !important;
    }
}

.service-textarea .vs-textarea {
    height: 150px;
}
</style>